import { useCallback } from 'react'
import {
  useUpdateUserLocaleMutation,
  type UpdateUserLocaleMutationVariables,
} from '../../__codegen__/api'

export const useUpdateUserLocale = () => {
  const [triggerMutation, { data, loading, error, called }] = useUpdateUserLocaleMutation()

  const submit = useCallback(
    (variables: UpdateUserLocaleMutationVariables) =>
      triggerMutation({
        variables,
      }),
    [triggerMutation]
  )

  return {
    submit,
    apiSuccess: data?.enterpriseAccountUpdateUserLocale && !error,
    apiLoading: loading,
    apiCalled: called,
    apiError: error,
  }
}
